import superagentDefaults from 'superagent-defaults'

const http_agent = superagentDefaults()
http_agent.set('subtype', 'html')
http_agent.set('npversion', '8.4.1')

export default http_agent
